module.exports = __webpack_public_path__ + "img/phb_cover.08cab27f.jpg";